<template>
  <div>
    <v-dialog
      v-model="showModal"
      persistent
      fullscreen
    >
      <div class="content-section">
        <br>
        <h1 class="header-style">
          Create Worker
        </h1>
        <br>
        <v-form
          ref="form"
          v-model="isFormValid"
          class="mt-6"
          lazy-validation
        >
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="firstName"
                label="First Name*"
                dense
                :rules="[(v) => !!v || 'This field is required']"
                filled
                color="#000000"
                light
                outlined
                background-color="#FFF"
                class="purple-input"
              />
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="lastName"
                label="Last Name*"
                filled
                :rules="[(v) => !!v || 'This field is required']"
                color="#000000"
                dense
                outlined
                background-color="#FFF"
                light
                class="purple-input"
              />
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="phoneNumber"
                label="Phone number"
                filled
                :rules="phoneNumberRules"
                color="#000000"
                outlined
                background-color="#FFF"
                dense
                persistent-hint
                light
                class="purple-input"
                type="number"
                :counter="15"
              />
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="email"
                label="Email"
                filled
                :rules="emailRules"
                color="#000000"
                outlined
                background-color="#FFF"
                dense
                persistent-hint
                light
                class="purple-input"
              />
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-select
                v-if="checkSiteManger"
                v-model="company"
                light
                color="#37474F"
                flat
                dense
                :items="appUserCompaniesList"
                item-text="name"
                item-value="id"
                label="Company"
                outlined
                background-color="#FFF"
                class="small-select"
                :rules="[(v) => !!v || 'This field is required']"
              />

              <v-select
                v-else
                v-model="company"
                light
                color="#37474F"
                flat
                dense
                :items="appUserCompaniesList"
                item-text="name"
                item-value="id"
                label="Company"
                outlined
                background-color="#FFF"
                class="small-select"
                disabled
                :rules="[(v) => !!v || 'This field is required']"
              />
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-select
                v-model="selectedCheckinType"
                light
                color="black"
                flat
                dense
                :items="chekinTypes"
                item-text="name"
                item-value="id"
                label="Checkin Type"
                outlined
                background-color="#FFF"
                class="small-select checkin"
                multiple
                :rules="[(v) => v.length > 0 || 'This field is required']"
              />
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-select
                v-model="workerCategories"
                light
                color="#37474F"
                flat
                dense
                :items="workerCategorylist"
                item-text="name"
                item-value="id"
                value="organization.external_id"
                label="Worker Category"
                outlined
                background-color="#FFF"
                class="small-select"
                :rules="validationRules"
                :disabled="isWorkerSelected"
              />
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-select
                v-model="country"
                light
                color="#37474F"
                flat
                dense
                :items="countriesListing"
                item-text="value"
                item-value="key"
                label="Country"
                outlined
                background-color="#FFF"
                class="small-select"
                :rules="[(v) => !!v || 'This field is required']"
              />
            </v-col>
          </v-row>
          <v-checkbox
            v-model="highRiskWorker"
            label="High Risk Worker"
            :disabled="isWorkerSelected"
            :class="isWorkerSelected?'class-disabled':''"
          >
            <template #label>
              <span :class="isWorkerSelected? 'disabled-class':''">High Risk Worker</span>
            </template>
          </v-checkbox>
          <p class="hint-text">
            User works under high risk category
          </p>
        </v-form>
        <v-btn
          class="btn-style"
          color="#64CA7F"
          elevation="0"
          @click="createWorker"
        >
          Create
        </v-btn>
        <v-btn
          class="btn-style grey-button"
          color="#E2E2E2"
          elevation="0"
          @click="showModal = false"
        >
          Cancel
        </v-btn>
        <v-btn
          fab
          color="#FFF"
          small
          rounded
          elevation="0"
          class="close-button"
          @click="showModal = false"
        >
          <v-icon color="#37474f">
            mdi mdi-close
          </v-icon>
        </v-btn>
      </div>
      <centre-spinner :loading="loading" />
    </v-dialog>
  </div>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
export default {
  name: 'AppUserCreateForm',
  components: {
    'centre-spinner': spinner,
  },
  props: {
    selectedOrgId: {
      type: String,
      default: null,
    },
    appUserRole: {
      type: String,
      default: null,
    },
    selectedCompany: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      email: '',
      role: 'worker',
      company: '',
      companyContractor: '',
      workerCategories: '',
      country: '',
      selectedCheckinType: [],
      valid: false,
      showModal: true,
      orgDetails: [],
      highRiskWorker: false,
      chekinTypes: [
        {
          name: 'Worker',
          id: 'worker',
        },
        {
          name: 'Visitor',
          id: 'visitor',
        },
      ],
      isFormValid: false,
      loading: false,
    };
  },
  computed: {
    appUserCompaniesList () {
      return this.$store.getters['company/getAppUsersCompanies'];
    },
    workerCategorylist () {
      return this.$store.getters['organization/getWorkerCategories'];
    },
    countriesList () {
      return this.$store.getters['countries/getCountries'];
    },
    CountryZipCodeList () {
      return this.$store.getters['countries/getCountries'];
    },
    countriesListing () {
      return Object.keys(this.CountryZipCodeList).map((key) => ({
        text: this.CountryZipCodeList[key],
        value: this.CountryZipCodeList[key],
      }));
    },
    checkSiteManger () {
      return this.appUserRole === 'site-manager';
    },
    checkWorker () {
      return this.appUserRole === 'worker';
    },
    isWorkerSelected () {
      if (this.selectedCheckinType.includes('worker')) {
        return false;
      }
      return true;
    },
    validationRules () {
      if (this.selectedCheckinType.includes('worker')) {
        return [(v) => !!v || 'This field is required'];
      } else {
        return [];
      }
    },
    phoneNumberRules () {
      return [
        (v) => !!v || 'This field is required',
        (v) => (v && v.length <= 15) || 'Phone number exceeded the limit.',
      ];
    },
    emailRules () {
      return [
        (v) => !!v || 'This field is required',
        (v) => /^.+@.+\..+$/.test(v) || 'Please enter a valid email address.',
      ];
    },
  },
  watch: {
    isWorkerSelected (newVal) {
      if (newVal) {
        this.workerCategories = '';
        this.highRiskWorker = false;
      }
    },
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },

  async mounted () {
    await this.getAppUserCompanies();
    await this.setFirstCompany();
    await this.getWorkerCategory();
    await this.getUserCountries();
    this.loading = false;
  },

  methods: {
    async getAppUserCompanies () {
      this.loading = true;
      await this.$store.dispatch('company/fetchAppUsersCompanies', {
        organizationId: this.selectedOrgId,
      });
    },
    async getWorkerCategory () {
      this.loading = true;
      await this.$store.dispatch('organization/fetchWorkerCategories', {
        externalId: this.selectedOrgId,
      });
    },
    async getUserCountries () {
      this.loading = true;
      await this.$store.dispatch('countries/fetchCountries');
      this.loading = false;
    },
    setFirstCompany () {
      if (this.appUserRole === 'contractor') {
        this.company = this.selectedCompany;
      }
    },
    async createWorker () {
      if (!this.$refs.form.validate()) {
        const emailValid = this.email && /^.+@.+\..+$/.test(this.email);
        const phoneValid = this.phoneNumber && this.phoneNumber.length <= 15;

        const messages = [];

        if (!emailValid) {
          messages.push('Please enter a valid email address.');
        }

        if (!phoneValid) {
          messages.push('Phone number must be less than 15 digits.');
        }

        if (messages.length > 0) {
          this.$store.dispatch(
            'alert/onAlert',
            {
              message: messages.join(' '),
              type: Constants.ALERT_TYPE_ERROR,
            },
            { root: true },
          );
          return;
        } else {
          this.$store.dispatch(
            'alert/onAlert',
            {
              message: 'Please fill the required field',
              type: Constants.ALERT_TYPE_ERROR,
            },
            { root: true },
          );
          return;
        }
      }
      this.loading = true;
      await this.$store
        .dispatch('appusers/createAppUser', {
          first_name: this.firstName,
          last_name: this.lastName,
          phone_number: this.phoneNumber,
          worker_category_id: this.workerCategories,
          email: this.email,
          user_role: this.role,
          company_id: this.company,
          country_code: this.country,
          high_risk_worker: this.highRiskWorker,
          types: this.selectedCheckinType,
          externalId: this.selectedOrgId,
        })
        .then((response) => {
          this.loading = false;
          this.showModal = false;
          this.$refs.form.reset();
          this.$store.dispatch(
            'alert/onAlert',
            {
              message: 'New Worker Created Successfully !',
              type: Constants.ALERT_TYPE_SUCCESS,
            },
            { root: true },
          );
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.theme--dark.v-list {
  background-color: white !important;
}
.v-input--selection-controls__input .v-icon {
  color: #ccc !important;
}
.theme--dark >>> .v-list-item {
  color: #37474f !important;
}
.theme--dark.v-label {
  color: rgba(255, 255, 255, 0.7);
}
.theme--dark.v-messages {
  color: #37474f !important;
}
.hint-text {
  font-size: 13px;
  color: #444444;
  margin-top: -13px !important;
}
.class-disabled .v-input--selection-controls__input .v-icon {
  color: #000 !important;
}
.disabled-class{
  color: #ccc !important;
}
.checkin .mdi-checkbox-marked::before{
  color: #0000 !important;
  caret-color: #0000 !important;
}

::v-deep .v-input--selection-controls__input .v-icon {
  color: rgb(8, 8, 8) !important;
}
</style>
